import React,{useState} from "react";
import { Swiper, SwiperSlide, } from 'swiper/react';
import Helper from '../functions/Helper.js';
/** @jsx jsx */
import {jsx} from '@emotion/core'
import Gallery from '../components/Gallery.js';

export default function ShoeImageSwiper(props){

  const [swiper, updateSwiper] = useState(null);
  const [showGallery,setShowGallery]=useState(false);
  const [activeSlide,setActiveSlide]=useState(0);

  let pictureArray=Object.values(props.pictures).sort((a,b)=>a.type - b.type);
  return(
    <>
    {pictureArray && showGallery &&
      <Gallery activeSlide={activeSlide} setActiveSlide={setActiveSlide} showGallery={showGallery} closeGallery={()=>{setShowGallery(false)}} pictures={pictureArray}/>
    }
    <div className="hover-swiper">
      <Swiper
        navigation={{nextEl: '.next-button-hover',prevEl: '.prev-button-hover'}}
        watchOverflow={true}
        onActiveIndexChange={(x)=>{setActiveSlide(x.activeIndex)}}
        spaceBetween={50}
        onSwiper={updateSwiper}
        pagination={{clickable: false}}
        onSwiper={(x)=>window.swiper=x}>
        {pictureArray.map((picture,index)=>{
          return(
            <SwiperSlide key={index}>
              <div style={{width:"100%",height:"100%",display:"flex",justifyContent:"center",alignItems:"flex-end"}}>
                <div style={{flex:1}}>
                  <div css={{
                      "@media (max-width:767px)":{paddingBottom:"80%",position:"relative"},
                      "@media (min-width:768px)":{paddingBottom:"65%",position:"relative"},
                    }}>
                    <div css={{position:"absolute",bottom:50,top:20,left:20,right:20,
                        "@media (min-width:1200px)":{left:80,right:80},
                        }}>
                        <picture>
                          <source
                            type="image/webp"
                            data-srcset={Helper.create_source_set({master:picture.master,thumbnails:"1"},585,"webp")}
                            sizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
                            />
                          <source
                            type="image/png"
                            data-srcset={Helper.create_source_set({master:picture.master,thumbnails:"1"},585)}
                            sizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
                            />
                        <img
                          onClick={()=>{setShowGallery(true)}}
                          width={picture.width}
                          height={picture.height}
                          className="lazyload"
                          css={{
                              cursor:"zoom-in",
                              objectPosition:"bottom center",
                              objectFit:"contain",
                              width:"100%",
                              height:"100%"}}
                          sizes="(max-width:767px) calc(100vw - 60px),585px"
                          data-srcset={Helper.create_source_set({master:picture.master,thumbnails:"1"},585)}
                          data-src={Helper.add_options_img(picture.master,585)}
                          data-expand={0}
                          />
                        </picture>

                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          )}
        )}
        <div className="swiper-button-next next-button-hover"></div>
        <div className="swiper-button-prev prev-button-hover "></div>
      </Swiper>
    </div>
    </>

  );
}
